import React from 'react';
import { Link } from 'react-router-dom';
import Modal from '../../components/Modal';

import imgBankBofA from '../../assets/images/bank-bofa.jpg';

const ConnectBank = () => (
  <div>
    <Modal className="connect-bank">
      <div className="card-header">
        <button className="btn-back" type="button">Back</button>
        <h5>Connect Bank of America</h5>
      </div>
      <div className="card-content">
        <div className="row">
          <div className="col-4">
            <img src={imgBankBofA} className="bank-logo" alt="Bank of America" />
          </div>
          <div className="col-8 bank-info">
            <p>Connect your account by entering your bank’s website login credentials.</p>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>
                <span>Email Address or Username</span>
                <input type="text" name="bank-username" />
              </label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>
                <span>Password</span>
                <input type="password" name="bank-password" />
              </label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Link to="/payment/confirmed" className="btn arrow">Connect Bank of America</Link>
          </div>
        </div>
      </div>
    </Modal>
  </div>
);

export default ConnectBank;
